import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/src/components/job-ranking/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout-new/jobseeker/index.tsx")